<template>
  <PageWrap :page-title="pageTitle">
    <LoadingIndicator
      v-if="loadingData"
      class="mt-5"
    />

    <template v-else>
      <PropertyStatusForm
        :data="formData"
        @update="updateForm"
        :errors="formErrors"
        :editing="isEditing"
      />

      <div class="mt-3">
        <BfButton
          v-if="!isEditing"
          @click="createEstadoInmueble"
        >
          Guardar
        </BfButton>

        <BfButton
          v-if="isEditing"
          variant="red"
          @click="deleteEstadoInmueble"
        >
          Eliminar
        </BfButton>
      </div>
    </template>
  </PageWrap>
</template>

<script>
import PropertyStatusForm from '@/components/FormGroups/PropertyStatusForm';
import FormSectionHeader from '@/components/FormSectionHeader';
import LoadingIndicator from '@/components/LoadingIndicator';
import PageWrap from '@/components/PageWrap';
import { propertyStatusTypeAPI } from '@/api';

export default {
  name: 'PropertyStatusesDetail',

  props: {
    id: {
      type: String,
    },
  },

  data() {
    return {
      formData: {},
      formErrors: {},
      loadingData: false,
    };
  },

  async created() {
    this.loadingData = true;

    try {
      if (this.isEditing) {
        await this.loadData();
      } else {
        await this.prepareForm();
      }
    } finally {
      this.loadingData = false;
    }
  },

  methods: {
    async loadData() {
      const {
        data: [data = {}],
      } = await propertyStatusTypeAPI.get(this.id);
      this.formData = data;
    },

    async prepareForm() {
      const { data } = await propertyStatusTypeAPI.preCreate();
      this.formData = data;
    },

    async updateForm({ key, value }) {
      const newData = { [key]: value };

      if (!this.isEditing) {
        this.formData = { ...this.formData, ...newData };
      } else {
        this.formErrors = {};

        try {
          const { data, message } = await propertyStatusTypeAPI.update({
            id: this.id,
            data: newData,
          });

          this.formData = data;
          this.$bfNotify({ title: 'Actualizado', message, type: 'success' });
        } catch ({ errors }) {
          this.formErrors = errors;
          this.$bfNotify({
            title: 'Error',
            message: 'Existe un error con tus datos',
            type: 'error',
          });
        }
      }
    },

    async createEstadoInmueble() {
      try {
        this.formErrors = {};
        const { data, message } = await propertyStatusTypeAPI.create(this.formData);

        this.$bfNotify({ title: 'Guardado', message, type: 'success' });
        this.$router.replace({
          name: 'estadoinmueble',
          params: { id: `${data.id}` },
        });
      } catch ({ errors, message }) {
        this.formErrors = errors;
        this.$bfNotify({
          title: 'Error',
          message: 'Existe un error con tus datos',
          type: 'error',
        });
      }
    },

    async deleteEstadoInmueble() {
      try {
        const { message } = await propertyStatusTypeAPI.delete(this.id);

        this.$bfNotify({ title: 'Eliminado', message, type: 'success' });
        this.$router.replace({ name: 'estadoinmuebles' });
      } catch ({ message }) {
        this.$bfNotify({ title: 'Error', message, type: 'error' });
      }
    },
  },

  computed: {
    isEditing() {
      return !!this.id;
    },

    pageTitle() {
      return this.isEditing ? `Estado: ${this.formData.nombre || ''}` : 'Crear Estado de Inmueble';
    },
  },

  components: {
    PropertyStatusForm,
    FormSectionHeader,
    LoadingIndicator,
    PageWrap,
  },
};
</script>
